import ActionTypes from "../constants/ActionTypes";
import axiosInstance from "../helpers/refreshTokenMiddleware";
import BASE_URL from '../constants/Api';

/* =========================================================
 * サイドメニュー取得処理
 * ========================================================= */
export const fetchMenuRequest = () => ({
  type: ActionTypes.FETCH_MENU_REQUEST
});

export const fetchMenuSuccess = (menuData) => ({
  type: ActionTypes.FETCH_MENU_SUCCESS,
  payload: menuData
});

export const fetchMenuFailure = (error) => ({
  type: ActionTypes.FETCH_MENU_FAILURE,
  payload: error
});

export const fetchMenuData = () => {
  return async (dispatch) => {
    dispatch(fetchMenuRequest());

    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        window.location.href = '/login';
        return;
      }

      const response = await axiosInstance.get(`${BASE_URL}/top/sidemenu`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      const menuData = response.data?.respons?.side_data_menu || [];

      dispatch(fetchMenuSuccess(menuData));

    } catch (error) {
      dispatch(fetchMenuFailure(error.message || 'メニュー情報の取得に失敗しました。'));
    }
  };
};

export const triggerFolderReload = () => ({
  type: ActionTypes.TRIGGER_DATA_FOLDER_RELOAD
});